export interface MatchScore {
  /** 3 = exact, 2 = starts-with, 1 = contains. */
  tier: 1 | 2 | 3;
  /** Lower is better — length of the matched name. */
  length: number;
}

export function scoreMatch(name: string, query: string): MatchScore | null {
  if (query === '') return { tier: 1, length: name.length };
  const n = name.toLowerCase();
  const q = query.toLowerCase();
  if (n === q) return { tier: 3, length: name.length };
  if (n.startsWith(q)) return { tier: 2, length: name.length };
  if (n.includes(q)) return { tier: 1, length: name.length };
  return null;
}

export function rankByScore<T>(items: T[], nameOf: (x: T) => string, query: string): T[] {
  type Scored = { item: T; name: string; score: MatchScore };
  const scored: Scored[] = [];
  for (const item of items) {
    const name = nameOf(item);
    const score = scoreMatch(name, query);
    if (score) scored.push({ item, name, score });
  }
  scored.sort((a, b) => {
    if (a.score.tier !== b.score.tier) return b.score.tier - a.score.tier;
    if (a.score.length !== b.score.length) return a.score.length - b.score.length;
    return a.name.localeCompare(b.name);
  });
  return scored.map((s) => s.item);
}
